<script>
import useSharedData from "@/use/SharedData";
import {onMounted, ref} from "vue";
import useTools from "@/use/Tools";
import {useDebtStore} from "@/stores/Debt";
import {useSecurityStore} from "@/stores/Security";
import axios from "axios";
import useSharedMethod from "@/use/SharedMethod";

export default {
    setup() {
        const {dialog, loading} = useSharedData();
        const {$route} = useTools();
        const {getBack, formatedDate, priceFormat, translateMonth} = useSharedMethod();
        const debtStore = useDebtStore();
        const securityStore = useSecurityStore();
        
        const deleteDialog = ref(false);
        
        const debt = ref(null);
        const refund = ref(null);
        
        
        function findById(id) {
            loading.value = true;
            axios.get(`/debts/${id}`).then((response) => {
                debt.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }
        
        function openRemoveDialog(r) {
            refund.value = r;
            deleteDialog.value = true;
        }
        
        function remove() {
            loading.value = true;
            axios.delete(`/debts/${debt.value.id}/refund/${refund.value.id}`).then(response => {
                refund.value = null;
                debtStore.updateDebt(response.data);
                debt.value = response.data;
            }).finally(() => {
                deleteDialog.value = false;
                loading.value = false;
            });
        }
        
        onMounted(() => findById($route.params.id));
        
        return {
            securityStore,
            dialog,
            loading,
            deleteDialog,
            debt,
            refund,
            remove,
            getBack,
            openRemoveDialog,
            formatedDate,
            priceFormat,
            translateMonth
        }
    },
}
</script>

<template>
    <div>
        <v-dialog v-model="deleteDialog" persistent max-width="500" scrollable>
            <v-card flat>
                <w-toolbar color="red" :title="$t('common.delete')"/>
                <v-card-text>
                    <v-container fluid>
                        <h2>{{ $t("debts.delete_refund_confirmation") }}</h2>
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="deleteDialog = false"/>
                    <w-btn-delete
                        show
                        :loading="loading"
                        @press="remove"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <v-dialog v-model="dialog" persistent max-width="900" scrollable>
            <v-card flat>
                <w-toolbar color="teal" :title="$t('debts.refund_history')"/>
                <v-card-text>
                    <v-simple-table dense>
                        <template v-slot:default>
                            <thead>
                            <tr>
                                <th></th>
                                <th class="text-left">{{ $t("common.date") }}</th>
                                <th class="text-left">{{ $t("common.month") }}</th>
                                <th class="text-left">{{ $t("common.price") }}</th>
                                <th class="text-left">{{ $t("common.type") }}</th>
                                <th class="text-left">{{ $t("common.observation") }}</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(r, index) in debt.refunds" :key="index">
                                <td>
                                    <v-icon
                                        v-if="r.valid"
                                        color="teal"
                                    >
                                        mdi-checkbox-marked-circle-outline
                                    </v-icon>
                                    <v-icon
                                        v-if="!r.valid"
                                        color="red"
                                    >
                                        mdi-checkbox-marked-circle-outline
                                    </v-icon>
                                </td>
                                <td>{{ formatedDate(r.date) }}</td>
                                <td>{{ translateMonth(r.month, true) }}</td>
                                <td>{{ priceFormat(r.price) }}</td>
                                <td>{{ $t(`debts.${r.type}`) }}</td>
                                <td>{{ r.observation }}</td>
                                <td>
                                    <w-btn-icon
                                        v-if=" !r.valid && securityStore.authorities['DELETE_DEBT']"
                                        icon="mdi-trash-can"
                                        color="red"
                                        @press="openRemoveDialog(r)"
                                    />
                                </td>
                            </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="getBack"/>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>